import React, { useEffect, useState } from "react";
import WifiIcon from "@mui/icons-material/Wifi";
import WifiOffIcon from "@mui/icons-material/WifiOff";

const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const updateStatus = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener("online", updateStatus);
    window.addEventListener("offline", updateStatus);

    return () => {
      window.removeEventListener("online", updateStatus);
      window.removeEventListener("offline", updateStatus);
    };
  }, []);

  return (
    <div className="flex items-center gap-2 ml-7">
      {isOnline ? (
        <WifiIcon className="text-green-500" fontSize="small" />
      ) : (
        <WifiOffIcon className="text-red-500" fontSize="small" />
      )}
      <span className="text-sm text-gray-700">
        {isOnline ? "Đã kết nối máy chủ" : "Mất kết nối máy chủ"}
      </span>
    </div>
  );
};

export default NetworkStatus;
